/**
 * Credit 服务 API 封装层
 *
 * 封装所有与积分、订阅、支付相关的 API 调用
 * @/app/hooks 必须通过此层调用,不能直接引用 @/app/services/credit
 */

import {
  clawPassGetMyClawPassStatus,
  clawPassGetMyCurrentCycleLedger,
  couponsGetAvailableCoupons,
  creditsGetMyCredits,
  marketingActivitiesClaimCoupons,
  nexusBindBonusCode,
  nexusClaimNexusRecord,
  nexusGetAvailableNexus,
  nexusGetMyBonusCodeBinding,
  nexusGetMyNexusHistory,
  nexusValidateBonusCode,
  ordersCreate,
  ordersGet,
  ordersGetProductWithOption,
  ordersListProductsWithOptions,
  ordersListStoreProducts,
  subscriptionsChangeSubscription,
  subscriptionsGetChangePreview,
  subscriptionsGetManagementPortal,
  subscriptionsGetMySubscription,
  trialsBatchGet,
} from '@/app/services/credit';

// 导出类型(供 hooks 使用)
export type {
  CreditV1ClaimNexusRecordRequest,
  CreditV1CreateOrderRequest,
  CreditV1GetMyNexusHistroyReply,
  CreditV1GetMySubscriptionReply,
  CreditV1GetOrderStateReply,
} from '@/app/services/credit';

/**
 * 获取我的积分
 */
export const getMyCredits = creditsGetMyCredits;

/**
 * 获取可用优惠券
 */
export const getAvailableCoupons = couponsGetAvailableCoupons;

/**
 * 领取用户在线触发(user_triggered)营销活动的优惠券。后端幂等，前台在线时(刷新/进入 home/pricing)调用即可。
 */
export const claimCoupons = marketingActivitiesClaimCoupons;

/**
 * 获取可用 Nexus
 */
export const getAvailableNexus = nexusGetAvailableNexus;

/**
 * 获取我的 Nexus 历史记录
 */
export const getMyNexusHistory = nexusGetMyNexusHistory;

export const bindBonusCode = nexusBindBonusCode;
export const getMyBonusCodeBinding = nexusGetMyBonusCodeBinding;

/**
 * 领取已完成且处于待领取状态的 Nexus 任务奖励
 */
export const claimNexusRecord = nexusClaimNexusRecord;

/**
 * 创建订单
 */
export const createOrder = ordersCreate;

/**
 * 获取订单详情
 */
export const getOrder = ordersGet;

/**
 * 获取产品选项
 */
export const getProductWithOption = ordersGetProductWithOption;

/**
 * 获取产品列表及选项
 */
export const listProductsWithOptions = ordersListProductsWithOptions;

/**
 * 获取积分商城商品列表
 */
export const listStoreProducts = ordersListStoreProducts;

/**
 * 变更订阅
 */
export const changeSubscription = subscriptionsChangeSubscription;

/**
 * 获取订阅变更预览
 */
export const getChangePreview = subscriptionsGetChangePreview;

/**
 * 获取订阅管理门户
 */
export const getManagementPortal = subscriptionsGetManagementPortal;

/**
 * 获取我的订阅信息
 */
export const getMySubscription = subscriptionsGetMySubscription;

/**
 * 批量获取试用信息
 */
export const batchGetTrials = trialsBatchGet;

/**
 * 校验福利码/达人合作码
 */
export const validateBonusCode = nexusValidateBonusCode;

/**
 * 获取当前用户的 Claw Pass 状态、额度和计费周期
 */
export const getMyClawPassStatus = clawPassGetMyClawPassStatus;

/**
 * 获取当前用户本计费周期的 Claw Pass 明细
 */
export const getMyClawPassCurrentCycleLedger = clawPassGetMyCurrentCycleLedger;
